<template>
  <div>
    <table class="tableTwoColumns">
      <tr class="tableTwoColumns__header">
        <th class="tableTwoColumns__cell">
          {{ title }}
        </th>
        <th class="tableTwoColumns__cell hidden-sm-only"></th>
      </tr>
      <gl-table-two-columns-row
        v-for="(row, index) in rows.filter(i => i.value !== undefined)"
        :key="index"
        :row="row"
        :min-column-title="minColumnTitle"
      />
    </table>
  </div>
</template>

<script>
import GlTableTwoColumnsRow from './components/GlTableTwoColumnsRow'

export default {
  name: 'GlTableTwoColumns',
  components: { GlTableTwoColumnsRow },
  props: {
    minColumnTitle: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.tableTwoColumns {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;

  &__header {
    background: rgba(255, 255, 255, 0.15);
  }

  &__cell {
    color: rgba(255, 255, 255, 0.54);
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    padding: 12px 16px;
    text-align: left;
    text-transform: uppercase;
    white-space: nowrap;
  }
}
</style>
